export const MAP_CONFIG = {
    DEFAULT_ZOOM: 12,
    LOCATION_ZOOM: 15,
    MIN_ZOOM: 1,
    MAX_ZOOM: 20,
    PADDING: 10,
    MAP_ID: "95d28c73960d6b8a",
} as const;

export const POLYLINE_STYLE = {
    strokeColor: "#0070d4",
    strokeOpacity: 1,
    strokeWeight: 4,
} as const;
